exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-container{max-width:580px;margin:0 auto}.app-container--back-header,.app-container--drawer-header{padding-top:44px}.app-container--navigation-footer{padding-bottom:50px}.app-container--fullwidth{max-width:none}.app_logoutimg{width:0;height:0;display:block}.main-contents{width:100%;min-height:100%}.loading-font{visibility:hidden}.loading-delay,.wf-active{visibility:visible}.nav-footer.unvisible{visibility:hidden;pointer-events:none;position:static!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f1c7b0b","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/AppContainer.vue
// module id = wFaO
// module chunks = 0 2